module.exports = __webpack_public_path__ + "static/media/afapp-ad.48a3197f.jpg";